
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M113 38a5 5 0 010 10H58a2 2 0 000 4h55a9 9 0 000-18 2 2 0 000 4zm4.87 28.87H54a2 2 0 000 4h63.87a6.13 6.13 0 010 12.26 2 2 0 000 4 10.13 10.13 0 000-20.26zM71 58a2 2 0 000 4h37a2 2 0 000-4z"}}),_c('path',{attrs:{"d":"M95 76H63a2 2 0 000 4h32a2 2 0 000-4z"}}),_c('path',{attrs:{"d":"M93 104h-7V86a2 2 0 00-4 0v18H41V24h41v18a2 2 0 004 0V22a2 2 0 00-2-2H39.62L11.14.35A2 2 0 008 2v60H2a2 2 0 00-2 2v11a2 2 0 004 0v-9h4v60a2 2 0 001.07 1.77 2 2 0 002.07-.12L39.62 108H93a2 2 0 000-4zM12 5.81l25 17.24V105l-25 17.19z"}})])
          )
        }
      }
    